export default __webpack_public_path__ + "static/media/WeD4.edaa166c.png";